import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=22164804"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,Login: require('/vercel/path0/components/login.vue').default,SearchAlgolia: require('/vercel/path0/components/searchAlgolia.vue').default,MenuItem: require('/vercel/path0/components/menuItem.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default})
